import { Injectable } from "@angular/core";
import { Observable, Subject, config } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';

@Injectable({
  providedIn: "root"
})
export class PortabilidadeService {

  constructor(private http: HttpClient, private util: UtilService) {

  }

  public enviarEmail(dados: any){

    return this.http
                .post(`${environment.apiURL}/Logado/Portabilidade/EnviarEmail`, dados);
  }

}
